import * as common from "./impl/common";
import * as frontend from "./frontend";
import * as overview from "./impl/overview";
import * as review from "./impl/review";
import * as test from "./impl/test";
import * as view from "./view";

export default view.View;

import { View, HeaderView, ListView, ItemView, ScoreView, SectionView, SettingsView, SummaryView } from "./view";
export { View, HeaderView, ListView, ItemView, ScoreView, SectionView, SettingsView, SummaryView };

export { common, frontend, overview, review, test, view };
